import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TickerCardComponent } from '../ticker-card/ticker-card.component';

@Component({
  selector: 'dk-opportunities-ticker',
  templateUrl: 'opportunities-ticker.component.html',
  standalone: true,
  imports: [CommonModule, TickerCardComponent],
})
export class OpportunitiesTickerComponent {
  @Input() data: any = null;
}
